<template>
	<Service class="orikaeshi">
		<h2>Services</h2>

		<p class="year">2015</p>

		<h3>
			折返し翻訳辞書<span class="subtitle">日本語から日本語へ</span>
		</h3>
		<p class="url"><a href="https://orikaeshi.com/">https://orikaeshi.com/</a></p>		
		<section class="logo content-box">
			<h4>Logo</h4>
			<img src="images/service/orikaeshi/logo.png" />
		</section>

	
		<section class="solution content-box">
			<h4>Story</h4>
			<h5>ハッカソンからうまれた、おかしな翻訳アプリ。</h5>
			<p>
				Androidアプリのプロトタイプを開発したエンジニアさんが、妖精が世界を旅するというコンセプトでつくられた翻訳アプリ。ハッカソンでは、キャラクターのみ関わっていたところ、懇親会のときにみんなで遊んでいたらとても面白かったことから、Androidアプリではなく皆ができるWebアプリとして作り直してはどうか？と思った。
			</p>
			<h5>Webアプリへ再開発、コンテストへ応募。</h5>
			<p>
				Webアプリへ開発し直しとともに、コンセプトを変更。世界各国で翻訳し、日本語に再び翻訳という形式に。名前も「折返し翻訳辞書」へ変更しました。コンテスト応募のため、最低限遊べるくらいまでを形にし夜に公開し、その後早朝にかけてTwitterで拡散された。
			</p>
			<h5>バズったその日。</h5>
			<p>
				拡散とサービス利用によって、最高瞬間アクセス数6,000人にまで増えた。NHKのWebニュースにもとりあげられ、しばらくSNSで話題となった。
			</p>
		</section>
		
		<section class="web-design">
			<h4>Web Design</h4>
			<img src="images/service/orikaeshi/screens.png" />
		</section>
	</Service>
</template>

<style lang="scss" scoped>
.orikaeshi {
	.top {
		img {
			width: 600px;
			margin: 0 auto;
		}
	}

	.logo {
		> img {
			width: 275px;
			margin-bottom: 30px;
		}

		p {
			width: 320px;
			margin: 0 auto;
		}
	}

	.about-service {
		width: 768px;
	}

	.target {
		> p {
			text-align: center;
		}
	}
	.service p.url{
		text-align: center;
	}
}


</style>

<script>
import Service from "@/components/Service.vue";

export default {
	components: {
		Service
	}
};
</script>
